import { useEffect, useState } from 'react';
import styled, { css } from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import ColorSetting, {
  type ColorSettingsProps,
} from 'hb-builder/components/common/SettingsLibrary/CommonSettings/ColorSetting';
import RadiosInput from 'hb-builder/components/common/SettingsLibrary/ComposedInputs/RadiosInput';
import InputTitle from 'hb-builder/components/common/SettingsLibrary/SettingsDecoration/InputTitle';
import { isColorFullyTransparent } from 'hb-builder/utils/colors';

type BackgroundColorModeProps = Pick<
  ColorSettingsProps,
  'color' | 'item' | 'networkColors' | 'networkTheming' | 'onChange'
>;

const BackgroundColorMode = ({
  color,
  item,
  networkColors,
  networkTheming,
  onChange,
}: BackgroundColorModeProps) => {
  const initialColor = item?.attributes?.bodyBackgroundColor;

  const [bgOption, setBgOption] = useState(
    initialColor && !isColorFullyTransparent({ color: initialColor })
      ? 'custom'
      : 'network',
  );

  useEffect(() => {
    if (bgOption === 'network') {
      onChange({
        settingKey: 'attributes.bodyBackgroundColor',
        value: undefined,
      });
    }
  }, [bgOption, onChange]);

  return (
    <>
      <InputTitle
        boxProps={{ mb: 3 }}
        id="body-bg-color-mode"
        label={s__('Builder|Page background')}
      />
      <Box>
        <RadiosInput
          direction="vertical"
          name="body-bg-color-mode"
          onChange={setBgOption}
          options={[
            { label: s__('Builder|Branding colors'), value: 'network' },
            { label: s__('Builder|Custom color'), value: 'custom' },
          ]}
          value={bgOption}
        />
        <FakeDisabledWrapper $isDisabled={bgOption !== 'custom'}>
          <ColorSetting
            boxProps={{ alignItems: 'flex-end', mb: 0 }}
            color={color}
            item={item}
            onChange={onChange}
            networkColors={networkColors}
            networkTheming={networkTheming}
            settingKey="bodyBackgroundColor"
            style={{ position: 'absolute', right: '70px', top: '-10px' }}
          />
        </FakeDisabledWrapper>
      </Box>
    </>
  );
};

export default BackgroundColorMode;

interface FakeDisabledWrapperProps {
  $isDisabled: boolean;
}

const FakeDisabledWrapper = styled(Box)`
  ${({ $isDisabled }: FakeDisabledWrapperProps) =>
    $isDisabled &&
    css`
      opacity: 0.6;
      pointer-events: none;
    `}
`;
